if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping')) || 49900;
      const minOrderThreshold = Number(this.getAttribute('data-min-order')) || 15000;
      const shippingFee = Number(this.getAttribute('data-shipping-fee')) || 5000;
      const cartTotal = Number(this.getAttribute('data-cart-total-amount')) || 0;
      const rate = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.rate) ? Number(Shopify.currency.rate) : 1;
      
      const targetFreeThreshold = Math.round(freeShippingThreshold * rate);
      const targetMinOrderThreshold = Math.round(minOrderThreshold * rate);
      const targetShippingFee = Math.round(shippingFee * rate);

      let shippingMessage = '';
      let shippingSuccess = false;
      let percentage = 0;
      let barFillStyle = '';
      let alertFillStyle = '';

      if ( cartTotal < targetMinOrderThreshold ) {
        const remainingToMin = targetMinOrderThreshold - cartTotal;
        const remainingAmount = this._formatMoney(remainingToMin, KROWN.settings.shop_money_format);
        const minAmount = this._formatMoney(targetMinOrderThreshold, KROWN.settings.shop_money_format);
        const feeAmount = this._formatMoney(targetShippingFee, KROWN.settings.shop_money_format);

        shippingMessage = `Add <strong>${remainingAmount}</strong> more for minimum order`;
        percentage = targetMinOrderThreshold > 0 ? Math.min(100, Math.max(0, Math.round((cartTotal / targetMinOrderThreshold) * 100))) : 0;
        barFillStyle = 'linear-gradient(90deg, #ff5722, #ff9800)';
        alertFillStyle = 'linear-gradient(90deg, #d32f2f, #f57c00)';
        try { sessionStorage.setItem('free_shipping_unlocked', 'false'); } catch(e){}
        window._hasCelebratedFreeShipping = false;
      } else if ( cartTotal < targetFreeThreshold ) {
        const freeShippingRemaining = targetFreeThreshold - cartTotal;
        const remainingAmount = this._formatMoney(freeShippingRemaining, KROWN.settings.shop_money_format);
        shippingMessage = `Add <strong>${remainingAmount}</strong> more for <strong>FREE Shipping</strong>`;
        percentage = targetFreeThreshold > 0 ? Math.min(100, Math.max(0, Math.round((cartTotal / targetFreeThreshold) * 100))) : 100;
        barFillStyle = 'linear-gradient(90deg, #ff9800, #4caf50)';
        alertFillStyle = 'linear-gradient(90deg, #f57c00, #2e7d32)';
        try { sessionStorage.setItem('free_shipping_unlocked', 'false'); } catch(e){}
        window._hasCelebratedFreeShipping = false;
      } else {
        shippingMessage = `🎉 You are eligible for <strong>FREE Shipping</strong>!`;
        shippingSuccess = true;
        percentage = 100;
        barFillStyle = '#4caf50';
        alertFillStyle = '#2e7d32';
      }

      const progressBarHTML = `
        <div class="shipping-notice__progress-bar" style="margin-top: 8px; width: 100%; background-color: rgba(255, 255, 255, 0.25); height: 8px; border-radius: 4px; overflow: hidden;">
          <div class="shipping-notice__progress-fill" style="width: ${percentage}%; height: 100%; background: ${barFillStyle}; transition: width 0.4s ease; border-radius: 4px;"></div>
        </div>
      `;

      if ( this.hasAttribute('data-show-alert') ) {
        const alertProgressBarHTML = `
          <div class="shipping-notice__progress-bar" style="margin-top: 8px; width: 100%; background-color: rgba(0, 0, 0, 0.1); height: 8px; border-radius: 4px; overflow: hidden;">
            <div class="shipping-notice__progress-fill" style="width: ${percentage}%; height: 100%; background: ${alertFillStyle}; transition: width 0.4s ease; border-radius: 4px;"></div>
          </div>
        `;
        this.innerHTML = `
          <div class="alert alert--wide alert--${shippingSuccess ? 'success' : (cartTotal < targetMinOrderThreshold ? 'error' : 'note')}" style="display: flex; flex-direction: column; align-items: stretch;">
            <div>${shippingMessage}</div>
            ${alertProgressBarHTML}
          </div>`;
      } else {
        this.innerHTML = `
          <div class="shipping-notice__wrapper" style="display: flex; flex-direction: column; text-align: center;">
            <span class="shipping-notice__text">${shippingMessage}</span>
            ${progressBarHTML}
          </div>
        `;
      }

      if ( shippingSuccess ) {
        let wasUnlockedBefore = false;
        try {
          wasUnlockedBefore = sessionStorage.getItem('free_shipping_unlocked') === 'false';
        } catch(e){}

        if ( wasUnlockedBefore ) {
          this._triggerCelebration();
        }
        try { sessionStorage.setItem('free_shipping_unlocked', 'true'); } catch(e){}
      }

    }

    _triggerCelebration() {
      if (window._hasCelebratedFreeShipping) return;
      window._hasCelebratedFreeShipping = true;

      const canvas = document.createElement('canvas');
      canvas.id = 'free-shipping-confetti-canvas';
      canvas.style.position = 'fixed';
      canvas.style.top = '0';
      canvas.style.left = '0';
      canvas.style.width = '100vw';
      canvas.style.height = '100vh';
      canvas.style.pointerEvents = 'none';
      canvas.style.zIndex = '999999';
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      document.body.appendChild(canvas);

      const ctx = canvas.getContext('2d');
      const colors = ['#4caf50', '#ff9800', '#2196f3', '#e91e63', '#9c27b0', '#ffeb3b', '#00bcd4', '#ff5722'];
      const particles = [];
      const particleCount = 110;

      for (let i = 0; i < particleCount; i++) {
        particles.push({
          x: Math.random() * canvas.width,
          y: -20 - Math.random() * 80,
          size: Math.random() * 9 + 5,
          color: colors[Math.floor(Math.random() * colors.length)],
          vx: (Math.random() - 0.5) * 7,
          vy: Math.random() * 4 + 4,
          rot: Math.random() * 360,
          vRot: (Math.random() - 0.5) * 12,
          shape: Math.random() > 0.4 ? 'rect' : 'circle'
        });
      }

      let startTime = null;
      function animate(timestamp) {
        if (!startTime) startTime = timestamp;
        const progress = timestamp - startTime;

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        particles.forEach(p => {
          p.x += p.vx;
          p.y += p.vy;
          p.rot += p.vRot;
          p.vy += 0.04; // gravity acceleration

          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate((p.rot * Math.PI) / 180);
          ctx.fillStyle = p.color;

          if (p.shape === 'rect') {
            ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 1.5);
          } else {
            ctx.beginPath();
            ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
            ctx.fill();
          }
          ctx.restore();
        });

        if (progress < 3200) {
          requestAnimationFrame(animate);
        } else {
          canvas.remove();
        }
      }

      requestAnimationFrame(animate);
    }
    
    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}